// extracted by mini-css-extract-plugin
export default {"toneGenerator":"toneGenerator--1SD-z","buttonSecondary":"buttonSecondary--3oJHC"};